export default "__VITE_ASSET__DXJhOp7g__"